import Copy from './src'

Copy.install = Vue => {
  Vue.component(Copy.name, Copy)
}

export default Copy
